module.exports = __webpack_public_path__ + "static/media/validacion_iconos_revisado.8c5d17f4.png";